import { render, staticRenderFns } from "./systemSettingsChangeLog.vue?vue&type=template&id=93947288&scoped=true&"
import script from "./systemSettingsChangeLog.vue?vue&type=script&lang=js&"
export * from "./systemSettingsChangeLog.vue?vue&type=script&lang=js&"
import style0 from "./systemSettingsChangeLog.vue?vue&type=style&index=0&id=93947288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93947288",
  null
  
)

/* custom blocks */
import block0 from "./systemSettingsChangeLog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports